/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_How_Step1_TitleInputs */

const en_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload your resume`)
};

const de_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lebenslauf hochladen`)
};

const fr_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Télécharge ton CV`)
};

const es_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube tu currículum`)
};

const it_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica il tuo curriculum`)
};

const nl_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload je CV`)
};

const pl_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wgraj swoje CV`)
};

const fi_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lataa ansioluettelosi`)
};

const da_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload dit CV`)
};

const sv_landing_how_step1_title = /** @type {(inputs: Landing_How_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ladda upp ditt CV`)
};

/**
* | output |
* | --- |
* | "Upload your resume" |
*
* @param {Landing_How_Step1_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_how_step1_title = /** @type {((inputs?: Landing_How_Step1_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_How_Step1_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_how_step1_title(inputs)
	if (locale === "fr") return fr_landing_how_step1_title(inputs)
	if (locale === "es") return es_landing_how_step1_title(inputs)
	if (locale === "it") return it_landing_how_step1_title(inputs)
	if (locale === "nl") return nl_landing_how_step1_title(inputs)
	if (locale === "pl") return pl_landing_how_step1_title(inputs)
	if (locale === "fi") return fi_landing_how_step1_title(inputs)
	if (locale === "da") return da_landing_how_step1_title(inputs)
	if (locale === "sv") return sv_landing_how_step1_title(inputs)
	return en_landing_how_step1_title(inputs)
});